import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-blue-900" style={{ fontFamily: '"Pacifico", serif' }}>
                IPSAS-EPSAS
              </h1>
            </div>
            <div className="flex items-center gap-4">
              <Link 
                to="/login" 
                className="px-6 py-2.5 bg-blue-900 text-white font-semibold rounded-lg hover:bg-blue-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Mitglieder-Login
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.8)), url('https://public.readdy.ai/ai/img_res/065e0957847334b4d478c6307856dd18.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              Willkommen auf der Plattform für <span className="text-blue-300">IPSAS</span> und <span className="text-blue-300">EPSAS</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
              Ihre zentrale Anlaufstelle für internationale und europäische Standards 
              der öffentlichen Rechnungslegung
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="mailto:registration@ipsas-epsas.de?subject=Registrierungsanfrage&body=Hallo,%0D%0A%0D%0AIch möchte mich gerne für die IPSAS-EPSAS Plattform registrieren.%0D%0A%0D%0AMit freundlichen Grüßen"
                className="px-8 py-4 bg-white text-blue-900 font-bold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer text-lg"
              >
                Jetzt registrieren und Mitglied werden
              </a>
              <Link 
                to="/login"
                className="px-8 py-4 border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-blue-900 transition-colors whitespace-nowrap cursor-pointer text-lg"
              >
                Bereits Mitglied? Anmelden
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Was Sie als Mitglied erwartet
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Umfassende Ressourcen und Tools für die erfolgreiche Implementierung 
              von IPSAS und EPSAS in Ihrer Organisation
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Feature 1 */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-news-line text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Aktuelle IPSAS/EPSAS-News
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Bleiben Sie auf dem neuesten Stand mit aktuellen Entwicklungen, 
                Änderungen und wichtigen Ankündigungen zu IPSAS und EPSAS Standards.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-book-line text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Leitfäden zur IPSAS-Einführung
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Detaillierte Schritt-für-Schritt Anleitungen und bewährte Praktiken 
                für die erfolgreiche Implementierung von IPSAS in Ihrer Organisation.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-exchange-line text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                HGB zu IPSAS/EPSAS Conversion
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Praktische Anleitungen und Tools für die Umstellung von HGB 
                auf IPSAS/EPSAS Rechnungslegungsstandards.
              </p>
            </div>

            {/* Feature 4 */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-checkbox-line text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                IPSAS-Readiness Assessment
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Interaktives Tool zur Bewertung der Bereitschaft Ihrer Organisation 
                für die IPSAS-Implementierung mit detailliertem Feedback.
              </p>
            </div>

            {/* Feature 5 */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-robot-line text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                KI-Chatbot für IPSAS/EPSAS
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Intelligenter Assistent für sofortige Antworten auf Ihre Fragen 
                zu IPSAS und EPSAS Standards und deren Anwendung.
              </p>
            </div>

            {/* Feature 6 */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-download-line text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Downloadbare Ressourcen
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Umfangreiche Bibliothek mit PDF-Leitfäden, Checklisten, 
                Templates und anderen praktischen Hilfsmitteln.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Für wen ist diese Plattform?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Speziell entwickelt für Fachkräfte im öffentlichen Sektor und der Wirtschaftsprüfung
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-government-line text-blue-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Kommunen & Öffentliche Hand</h3>
              <p className="text-gray-600 leading-relaxed">
                Städte, Gemeinden, Landkreise und andere öffentliche Einrichtungen, 
                die IPSAS/EPSAS implementieren möchten.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-briefcase-line text-blue-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Wirtschaftsprüfer</h3>
              <p className="text-gray-600 leading-relaxed">
                Prüfungsgesellschaften und Wirtschaftsprüfer, die ihre Mandanten 
                bei der IPSAS/EPSAS-Umstellung begleiten.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-user-star-line text-blue-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Finanzexperten</h3>
              <p className="text-gray-600 leading-relaxed">
                Finanzverantwortliche, Controller und Berater im öffentlichen Sektor 
                und in beratenden Unternehmen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Bereit für den nächsten Schritt?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Werden Sie Mitglied und erhalten Sie Zugang zu allen Ressourcen, 
            Tools und Expertenwissen für eine erfolgreiche IPSAS/EPSAS-Implementierung.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="mailto:registration@ipsas-epsas.de?subject=Registrierungsanfrage&body=Hallo,%0D%0A%0D%0AIch möchte mich gerne für die IPSAS-EPSAS Plattform registrieren.%0D%0A%0D%0AMeine Organisation:%0D%0AMeine Position:%0D%0AMeine Telefonnummer:%0D%0A%0D%0AMit freundlichen Grüßen"
              className="px-8 py-4 bg-white text-blue-900 font-bold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer text-lg"
            >
              <i className="ri-mail-line mr-2"></i>
              Jetzt per E-Mail registrieren
            </a>
            <Link 
              to="/login"
              className="px-8 py-4 border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-blue-900 transition-colors whitespace-nowrap cursor-pointer text-lg"
            >
              Bereits Mitglied? Anmelden
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <h5 className="text-white font-bold text-lg mb-4">IPSAS-EPSAS</h5>
              <p className="text-sm leading-relaxed">
                Ihre zentrale Plattform für internationale und europäische 
                Standards der öffentlichen Rechnungslegung
              </p>
            </div>

            <div>
              <h5 className="text-white font-bold text-lg mb-4">Plattform</h5>
              <ul className="space-y-2 text-sm">
                <li>
                  <a 
                    href="mailto:registration@ipsas-epsas.de?subject=Registrierungsanfrage"
                    className="hover:text-white transition-colors cursor-pointer"
                  >
                    Registrierung
                  </a>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white transition-colors cursor-pointer">
                    Login
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h5 className="text-white font-bold text-lg mb-4">Ressourcen</h5>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/login" className="hover:text-white transition-colors cursor-pointer">
                    IPSAS Standards
                  </Link>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white transition-colors cursor-pointer">
                    EPSAS Standards
                  </Link>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white transition-colors cursor-pointer">
                    Public Sector Accounting
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h5 className="text-white font-bold text-lg mb-4">Kontakt</h5>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/impressum" className="hover:text-white transition-colors cursor-pointer">
                    Impressum
                  </Link>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white transition-colors cursor-pointer">
                    Datenschutz
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm">
            <p>&copy; 2024 IPSAS-EPSAS.de. Alle Rechte vorbehalten.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-400 hover:text-white transition-colors cursor-pointer mt-4 md:mt-0"
            >
              Join Us!
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
